import PhoneInput from './phone-input';

export default PhoneInput;
